import { InfoIcon } from "../svgs/SVGS"
import "./infobox.css"

const InfoBox = () => {
  return (
    <div className="info-box-background">
      <InfoIcon></InfoIcon>
      <span>
        If you previously installed the tag through other methods, please remove
        it and add it through the plugin.
      </span>
    </div>
  )
}

export default InfoBox
